import { Container } from '@ace-clublabs/shared-component-library';
import { Pages } from '@lib/types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

interface PushStateDetail {
  state: any;
  title: string;
  url?: string | null;
}

export const AppContainer = (props: any) => {
  const location = useLocation();

  const [useDesktopLayout, setUseDesktopLayout] = useState(false);

  useEffect(() => {
    const pageWithDesktopLayout = [Pages.BenefitsPage as string].includes(location.pathname);
    const isShowingBenefitPage = location.search.includes('isChangingMembershipLevel=true');
    setUseDesktopLayout(pageWithDesktopLayout || isShowingBenefitPage);

    const customPushState = (event: CustomEvent<PushStateDetail>) => {
      if (event.detail.url?.includes('isChangingMembershipLevel=true')) {
        setUseDesktopLayout(true);
      }
    };
    // @ts-ignore
    window.addEventListener('custom:pushstate', customPushState);

    return () => {
      // @ts-ignore
      window.removeEventListener('custom:pushstate', customPushState);
    };
  }, [location]);

  const appContainer = (
    <Container
      className={`${useDesktopLayout ? 'fluid-container' : 'static-container'}`}
      sx={(theme) => ({
        /**
         * Desktop layout styling is set for Benefits page only
         * sm is for Benefits page mobile view
         * theme.breakpoints.up('lg') is for Benefits page desktop view
         * 480px and 534px are for all other pages
         */
        maxWidth: useDesktopLayout ? 'sm' : '480px !important',
        ...(useDesktopLayout && {
          [theme.breakpoints.up('lg')]: { maxWidth: 'xl' },
        }),
        ...(!useDesktopLayout && {
          '@media (min-width:768px)': {
            maxWidth: '602px !important',
          },
        }),
      })}
    >
      {props.children}
    </Container>
  );
  return appContainer;
};
